document.querySelectorAll('.featured-collection-tabs').forEach(section => {
  const tabNavButtons = section.querySelectorAll('.fct-tab-nav');
  const tabContents = section.querySelectorAll('.fct-tab-content');

  function refreshSliderInTab(tabPanel) {
    const sliderComponent = tabPanel.querySelector('slider-component');
    const slider = tabPanel.querySelector('.slider');

    if (!slider) return;

    slider.scrollLeft = 0;

    requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));

      if (sliderComponent) {
        if (typeof sliderComponent.resetPages === 'function') {
          sliderComponent.resetPages();
        }
        if (typeof sliderComponent.initPages === 'function') {
          sliderComponent.initPages();
        }
        if (typeof sliderComponent.update === 'function') {
          sliderComponent.update();
        }
      }
    });
  }

  function activateTab(index) {
    tabNavButtons.forEach((btn, i) => {
      const isActive = i === index;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    tabContents.forEach((content, i) => {
      const isActive = i === index;
      content.classList.toggle('active', isActive);

      if (isActive) {
        content.removeAttribute('hidden');

        clearKeywordActive(content);
        showAllItems(content);

        const defaultKeyword = content.querySelector('.fct-keyword[data-default="true"]');
        if (defaultKeyword) defaultKeyword.click();

        refreshSliderInTab(content);
      } else {
        content.setAttribute('hidden', '');
      }
    });
  }

  function clearKeywordActive(tabPanel) {
    tabPanel.querySelectorAll('.fct-keyword.active').forEach(el => el.classList.remove('active'));
  }

  function getItems(tabPanel) {
    const items = tabPanel.querySelectorAll('[data-fct-item]');
    if (items && items.length) return Array.from(items);
    return Array.from(tabPanel.querySelectorAll('.grid__item'));
  }

  function showAllItems(tabPanel) {
    const items = getItems(tabPanel);
    items.forEach(item => {
      item.style.removeProperty('display');
      item.removeAttribute('aria-hidden');
    });
  }

  function normalize(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function itemMatches(item, scope, value) {
    const val = normalize(value);

    if (!val) return true;
    if (scope === 'none') return true;

    if (scope === 'tag') {
      const tags = normalize(item.dataset.tags).split('|').map(t => t.trim()).filter(Boolean);
      return tags.includes(val);
    }

    if (scope === 'vendor') {
      return normalize(item.dataset.vendor) === val;
    }

    if (scope === 'product_type') {
      return normalize(item.dataset.type) === val;
    }

    return true;
  }

  function applyFilter(tabPanel, scope, value) {
    const items = getItems(tabPanel);

    if (!value || scope === 'none') {
      showAllItems(tabPanel);
      return;
    }

    items.forEach(item => {
      const keep = itemMatches(item, scope, value);
      if (keep) {
        item.style.removeProperty('display');
        item.removeAttribute('aria-hidden');
      } else {
        item.style.display = 'none';
        item.setAttribute('aria-hidden', 'true');
      }
    });
  }

  document.querySelectorAll('.fct-keyword').forEach(keyword => {
    keyword.addEventListener('click', function (e) {
      const tabIndex = parseInt(this.getAttribute('data-tab-index'), 10);
      const scope = this.getAttribute('data-filter-scope') || 'none';
      const tag = this.getAttribute('data-filter-tag') || '';

      const tabPanel = document.querySelector(`.fct-tab-content[data-tab-index="${tabIndex}"]`);
      if (!tabPanel) return;

      if (tag && scope && scope !== 'none') {
        e.preventDefault();

        clearKeywordActive(tabPanel);
        this.classList.add('active');

        applyFilter(tabPanel, scope, tag);

        const slider = tabPanel.querySelector('.slider');
        if (slider) slider.scrollTo({ left: 0, behavior: 'smooth' });

        refreshSliderInTab(tabPanel);
      }
    });
  });

  if (tabNavButtons.length > 0) activateTab(0);

  tabNavButtons.forEach((btn, index) => {
    btn.addEventListener('click', function () {
      activateTab(index);
    });
  });
});